import React from 'react';
import { Clapperboard } from 'lucide-react';
import { Contenuto } from '../types';

// 02/11/2026 (Michel): i reel montati da Opus in edit.bymarke.com prendono da soli la spunta «Montato»
// (drive.bymarke.com, server/incrocio/montati.ts, colonna contents.montato_da = 'opus'). L'etichetta dice
// che il montaggio si trova su Edit; sparisce se un videoeditor cambia la spunta a mano.
export default function OpusBadge({ contenuto }: { contenuto: Contenuto }) {
  if (!contenuto.videoMontato || contenuto.montatoDa !== 'opus') return null;
  // Il progetto in Edit (contents.montato_link): colonna sua, non il «Video montato» che vede anche il cliente.
  const link = contenuto.montatoLink?.startsWith('https://edit.bymarke.com/') ? contenuto.montatoLink : 'https://edit.bymarke.com/edit';
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-medium border bg-violet-100 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300 border-violet-200 dark:border-violet-800 hover:bg-violet-200 dark:hover:bg-violet-900/50"
      title="Montato da Opus: il reel si trova su edit.bymarke.com (clic per aprirlo)">
      <Clapperboard size={10} className="flex-shrink-0" />
      Editato da Opus
    </a>
  );
}
